// import axios from "./axiosInstance";

// const homePageAPI = {
//   details: () => axios.get("details"),

//   homePage: (payload) => axios.post("homepage", payload),

//   fetchDetailsUsingSlug: (payload) =>
//     axios.post("fetchDetailsUsingSlug", payload),

//   fetchCategories: () => axios.post("homepage/category-for-navbar"),
// };

// export default homePageAPI;


import axios from "./axiosInstance";
import db from "../data/db.json";

// ─── Mock ────────────────────────────────────────────────────────────────────
const mockAPI = {
  // Home.js → homePageAPI.homePage(payload)
  // Returns banners, categories, coupons, products, topSellerProducts, testimonials, blogs
  homePage: async () => {
    return db.homePage;
  },

  // CategoryContext.js → homePageAPI.fetchCategories()
  // Header/Navbar ke liye categories chahiye hoti hain
  // db.json mein homePage.data.categories se le lete hain
  fetchCategories: async () => {
    return {
      code: 200,
      message: "Categories fetched successfully",
      success: true,
      data: db.homePage.data.categories,
    };
  },

  // Agar kahi use ho toh — fallback mock
  details: async () => {
    return {
      code: 200,
      message: "Details fetched",
      success: true,
      data: {},
    };
  },

  // Agar kahi use ho toh — fallback mock
  fetchDetailsUsingSlug: async (payload) => {
    return {
      code: 200,
      message: "Details fetched",
      success: true,
      data: {},
    };
  },
};

// ─── Real ────────────────────────────────────────────────────────────────────
const realAPI = {
  details: () => axios.get("details"),
  homePage: (payload) => axios.post("homepage", payload),
  fetchDetailsUsingSlug: (payload) => axios.post("fetchDetailsUsingSlug", payload),
  fetchCategories: () => axios.post("homepage/category-for-navbar"),
};

// ─── Export ──────────────────────────────────────────────────────────────────
const homePageAPI =
  process.env.REACT_APP_USE_MOCK === "true" ? mockAPI : realAPI;

export default homePageAPI;